// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.additional-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  margin: 25px 0 0 0;
}

.additional-detail {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.additional-detail .additional-label {
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
  margin: 0;
}

.additional-detail .ant-input,
.additional-detail .ant-picker {
  width: 100%;
  height: 36px;
  border-radius: 6px;
}

.additional-value {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 0 11px;
  overflow-wrap: anywhere;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #f5f5f5;
  color: #262626;
}`, "",{"version":3,"sources":["webpack://./src/components/DocumitraAdditionalDetail/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,gDAAA;EACA,SAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AACF;;AAEA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AACF","sourcesContent":[".additional-container {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 20px;\n  margin: 25px 0 0 0;\n}\n\n.additional-detail {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.additional-detail .additional-label {\n  font-weight: 600;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #64748b;\n  margin: 0;\n}\n\n.additional-detail .ant-input,\n.additional-detail .ant-picker {\n  width: 100%;\n  height: 36px;\n  border-radius: 6px;\n}\n\n.additional-value {\n  display: flex;\n  align-items: center;\n  min-height: 36px;\n  padding: 0 11px;\n  overflow-wrap: anywhere;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  background: #f5f5f5;\n  color: #262626;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
